import store from '~/store'

export default (to, from, next) => {
  if (!store.getters['auth/isEditor']) {
    if(from.name) next({ name: from.name })
    	else next('/')
  } else {
    next()
  }
}
